/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneFactbox from 'base/components/standalone/Factbox';

export const DynamicStandaloneFactbox = StandaloneFactbox;
export type DynamicStandaloneFactboxProps = PropsFromComponent<typeof StandaloneFactbox>;

export const DynamicStandaloneFactboxWith = (extras: DynamicStandaloneExtras): typeof StandaloneFactbox => {
    return function DynamicStandaloneFactbox(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Factbox');
        return <StandaloneFactbox {...mergeProps({ options: { theme } }, props)} />;
    }
}